import spritePath from '@/assets/icons.svg';

export default function getMarkerIcon(isFavorite: boolean): string {
  return `${spritePath}#${isFavorite
    ? import.meta.env.VITE_STORE_FINDER_FLAG_ACTIVE
    : import.meta.env.VITE_STORE_FINDER_FLAG_DEFAULT}`;
}
